// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-tile-alert-box{border-radius:8px}.product-tile-alert-box--warning{background-color:#ffe263}.product-tile-alert-box--info{background-color:#b9e9fa}", ""]);
// Exports
module.exports = exports;
